import { useStore } from 'vuex'
import { computed } from 'vue'

export default {
    name: "FundraisingQrCodeOverlay",
    setup(){
        const store = useStore()
        const qrImgUrlBase = computed(() => store.state.main.page_overlay_content_data.qrImgUrlBase)
        const qrPrintPageLink = computed(() => {
            
            return store.state.main.page_overlay_content_data.qrPrintPageLink + "?id=" + store.state.main.page_overlay_content_data.fundraisingCampaignId
        })
        const qrPrintPageLinkTarget = computed(() => store.state.main.page_overlay_content_data.qrPrintPageLinkTarget)

        const closeOverlay = function() {
            store.dispatch('main/closePageOverlay')
        }

        const handleRegret = () => {
            closeOverlay()   
        };
        

        const getLabel = (labelKey, replacements) => {
            let label = store.getters['labels/getLabel']({ labelCollection: 'FundraisingQrCodeOverlay', labelKey: labelKey })
            if (replacements) {
                replacements.forEach((replacement, index) => {
                    label = label.replace(`{${index}}`, replacement)
                })
            }
            return label
        }

        return {
            getLabel,
            handleRegret,
            qrImgUrlBase,
            qrPrintPageLink,
            qrPrintPageLinkTarget 
        }
        
        
    }
}